import { css } from '@emotion/react';
import { getColor } from '@atlassiansox/wpl-utils';

export const pdfLayoutContainer = css`
  position: relative;
`;

export const verticalLine = css`
  height: 43px;
  border-left: 1px solid ${getColor('n50')};
  flex-shrink: 0;
  stroke-width: 1px;
`;

const headerText = css`
  color: ${getColor('n800')};
  font-family: var(--bxp-charlie-display-font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  word-break: break-word;
`;

export const headerContainer = css`
  display: flex;
  width: 856px;
  padding-bottom: 0px;
  align-items: flex-start;
  gap: 15px;
`;

export const atlassianLogoContainer = css`
  display: flex;
  align-items: center;
  align-self: stretch;
`;

export const atlassianHeaderContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
`;

export const dateStyle = css`
  font-family: var(--bxp-charlie-text-font-family);
  color: ${getColor('n700')};
  line-height: 24px;
  font-size: 16px;
  white-space: nowrap;
  padding-bottom: 6px;
`;

const estimateDateText = css`
  display: flex;
  width: 120px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
`;

export const estimateDateText1 = css`
  ${estimateDateText}
  margin-right: 24px;
`;

export const estimateDateText2 = css`
  ${estimateDateText}
  width: 200px;
  padding-left: 24px;
`;

export const estimateDateContainer = css`
  display: flex;
  width: 464px;
  align-items: flex-start;
`;

export const estimateOnlyContainer = css`
  display: flex;
  padding: 24px 32px;
  align-items: flex-start;
  flex: 1 0 0;
  flex-direction: column;
  gap: 10px;
  border: 8px solid ${getColor('n30')};
  background: #fff;
`;

export const productFamilyNameText = css`
  color: ${getColor('n800')};
  font-family: var(--bxp-charlie-text-font-family);
  font-size: 16px;
  text-transform: none;
  font-weight: 600;
  line-height: 24px;
`;

const productInformationText = css`
  ${productFamilyNameText}
  letter-spacing: 0;
  white-space: nowrap;
  font-weight: 400;
`;

const pricingMessageText = css`
  ${productInformationText}
  font-size: 14px;
  line-height: 18px;
`;

export const pricingMessageContainer = css`
  ${pricingMessageText}
  display: flex;
  width: 804px;
  padding: 0px 0px 32px 52px;
  align-items: flex-start;
  gap: 16px;
  white-space: wrap;
  word-break: break-word;
`;

export const pdfContainer = css`
  position: relative;
  display: flex;
  padding: 100px 128px 60px 128px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  align-self: stretch;
`;

export const productHeaderBarStyle = css`
  ${headerText}
  display: flex;
  padding: 16px 0 0 0;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  flex-wrap: wrap;
`;

export const productHeaderBoxStyle = css`
  .header {
    display: flex;
    padding: 16px 0 16px 0;
  }

  .box {
    display: flex;
    column-gap: 2px;
    border: 1px solid #fff;
    padding: 4px 16px 4px 8px;
    height: 50px;
    background: ${getColor('n30')};
    line-height: 21px;
  }

  .box1 {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    width: 260px;
  }

  .box2 {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    width: 130px;
  }

  .box3 {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 158px;
    text-align: right;
  }

  .box4 {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-align: right;
    width: 142px;
  }

  .box5 {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    width: 165px;
  }
`;

export const productRowStyle = css`
  .pdf-row {
    display: flex;
    padding: 16px 0 16px 0px;
    align-items: center;
  }

  .col {
    ${productInformationText}
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .col1 {
    justify-content: flex-start;
    gap: 16px;
    width: 260px;
    overflow-wrap: break-word;
    padding-left: 2px;
    text-wrap: wrap;
  }

  .col2 {
    width: 130px;
    padding-right: 16px;
  }

  .col3 {
    width: 158px;
    text-align: right;
    padding-right: 16px;
  }

  .col4 {
    text-align: right;
    width: 142px;
    padding-right: 16px;
  }

  .col5 {
    width: 165px;
    padding-right: 16px;
  }
`;

export const multiProductRowStyle = css`
  .pdf-row {
    display: flex;
    padding: 16px 0 16px 0;
    align-items: center;
  }

  .col {
    ${productInformationText}
    display: flex;
  }

  .col1 {
    display: flex;
    justify-content: flex-start;
    width: 260px;
    gap: 16px;
    text-wrap: wrap;
  }

  .col2 {
    display: flex;
    justify-content: flex-end;
    width: 130px;
    padding-right: 16px;
  }

  .col3 {
    display: flex;
    justify-content: flex-end;
    width: 158px;
    text-align: right;
    padding-right: 16px;
  }

  .col4 {
    display: flex;
    justify-content: flex-end;
    text-align: right;
    width: 142px;
    padding-right: 16px;
  }

  .col5 {
    display: flex;
    justify-content: flex-end;
    width: 165px;
    padding-right: 16px;
  }
`;

export const pricingInformationContainer = css`
  border-top: 2px solid ${getColor('n30')};
  display: flex;
  flex-direction: row;
  padding: 25px 16px 16px 0px;
  align-items: flex-end;
  gap: 8px;
  align-self: stretch;
  justify-content: space-between;
`;

export const billingCycleContainer = css`
  align-items: center;
  justify-content: flex-start;
  width: 312px;
  flex-shrink: 0;
`;

export const estimatedCostContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: stretch;
`;

export const billingCycleText = css`
  color: ${getColor('n400')};
  text-transform: capitalize;
  font-family: var(--bxp-charlie-display-font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`;

export const taxInformationText = css`
  color: ${getColor('n400')};
  font-family: var(--bxp-charlie-display-font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  padding-bottom: 6px;
`;

export const totalPriceText = css`
  ${headerText}
  text-align: right;
  font-size: 36px;
  font-style: normal;
  line-height: 44px;
`;

export const currencyText = css`
  ${headerText}
  font-family: var(--bxp-charlie-display-font-family);
  font-size: 16px;
  line-height: 32px;
  align-self: flex-end;
`;

export const estimateOnlyText = css`
  color: ${getColor('n800')};
  text-transform: capitalize;
  font-family: var(--bxp-charlie-display-font-family);
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.3px;
`;

export const estimateMessageText = css`
  width: 318px;
  color: ${getColor('n400')};
  font-family: var(--bxp-charlie-display-font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const footerContainer = css`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-self: flex-end;
  flex-shrink: 0;
`;

export const pageNumberContainer = css`
  position: absolute;
  width: 81px;
  bottom: 0;
  right: 128px;
`;
